import { getStoreCatalogue } from "services/commonServices";
import { GET_STORE_CATALOGUE_FAILURE, GET_STORE_CATALOGUE_REQUEST, GET_STORE_CATALOGUE_SUCCESS } from "./action-type";
import { SOMS_API_KEY } from "services/CONSTANTS";

export const getStoreCatalogueAction = (type) => {

    const request = {
      apikey: SOMS_API_KEY,
      type: type
    }

    return (dispatch) => {
        dispatch(getStoreCatalogueRequest());
        getStoreCatalogue(request)
            .then((response) => {
                if (response.status === 200)
                    dispatch(getStoreCatalogueSuccess(response));
                else
                    dispatch(getStoreCatalogueFailure(response));
            })
            .catch((err) => {
                dispatch(getStoreCatalogueFailure(err));
            });

    };
}

export const getStoreCatalogueRequest = () => {
    return {
        type: GET_STORE_CATALOGUE_REQUEST
    }
};

export const getStoreCatalogueSuccess = (response) => {
    return {
        type: GET_STORE_CATALOGUE_SUCCESS,
        getStoreCatalogueResponse: response.data,
        isGetStoreCatalogueError: false,
        isGetStoreCatalogueSuccess: true
    }
};

export const getStoreCatalogueFailure = (error) => {
    return {
        type: GET_STORE_CATALOGUE_FAILURE,
        getStoreCatalogueResponse: error,
        isGetStoreCatalogueError: true,
        isGetStoreCatalogueSuccess: false
    }
};